import React from 'react';
import Modal from '../../../Components/Modal';
import Form, { Actions, RecordedTime } from '../../../Components/Form';
import { useCustomer } from '../../../Data/Customers';
import { getOccurrence } from '../../../Services/recordedTime';

const RecordedTimeModal = ({job, onClose, then}) => {
    return <Modal title="Recorded time" isOpen={!!job} setIsOpen={onClose} dismissible>
        {job && <Inner {...{job, then}} />}
    </Modal>
}

const Inner = ({job, then}) => {
    const {recordJobOccurrenceTime} = useCustomer(job.customerId);
    const occurrence = getOccurrence(job);

    return <Form
        data={{ recordedTime: occurrence?.recordedTime ?? { periods: [] } }}
        onSubmit={(data) => recordJobOccurrenceTime(job.id, occurrence.id, data).then(() => then && then())}
        closeModalOnSubmit
    >
        <RecordedTime />
        <Actions submit={{label: 'Save'}} />
    </Form>
}

export default RecordedTimeModal;
